import { useContext } from "react";
import LocaleContext from "../locale/LocaleContext";
export const useLocale = () => useContext(LocaleContext);
